import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que reciben los servicios de API's externos
export const EXTERNAL: StringValues = {
    parameters: "params",
    variable: "variable",
    manager: "encargado",
    process: "proceso",
    operation: "ope",
    entity: "entity",
    entities: "nits",
    enMonth: "month",
    enYear: "year",
    enDate: "date",
    month: "mes",
    year: "anio",
    web: "web",
};
